import { LayoutPage } from '@/components/hoc';
import { Separator } from '@/components/ui';
import { Outlet } from 'react-router-dom';
import { Calendar } from 'lucide-react';

const EventsPage = () => {
	return (
		<LayoutPage
			header={{
				description: 'Gestion des événements in-app (Blind Dating, etc.).',
				title: 'Événements',
			}}
			breadcrumb={{
				title: 'Événements',
				subMenus: [],
			}}
			icon={Calendar}
		>
			<div className="flex flex-col space-y-3">
				<Separator className="bg-muted" />
				<Outlet />
			</div>
		</LayoutPage>
	);
};

export default EventsPage;
